/* eslint-disable filenames/match-exported */
/** @jsx jsx */
import { Text } from '@datacamp/waffles/text';
import { tokens } from '@datacamp/waffles/tokens';
import { jsx } from '@emotion/react';
import React from 'react';

const listStyle = {
  padding: 0,
  margin: 0,
  paddingLeft: tokens.spacing.large,
};

const listItemStyle = {
  lineHeight: tokens.lineHeights.relaxed,
};

type ListProps = {
  ordered?: boolean;
} & React.HTMLAttributes<HTMLUListElement>;

const List: React.FC<ListProps> = ({ children, ordered, ...restProps }) => {
  const Element = ordered ? 'ol' : 'ul';

  return (
    <Element {...restProps} css={listStyle}>
      {children}
    </Element>
  );
};

type ListItemProps = { children: React.ReactNode } & React.LiHTMLAttributes<
  HTMLLIElement
>;

const ListItem: React.FC<ListItemProps> = ({ children, ...restProps }) => {
  return (
    <Text as="li" {...restProps} css={listItemStyle}>
      {children}
    </Text>
  );
};

const ListNamespace = Object.assign(List, {
  Item: ListItem,
});

export default ListNamespace;
